import { transparentNeutralClasses } from '@liveauctioneers/hammer-ui-core/iconButton';
import { ArrowsOutSimple } from '@liveauctioneers/hammer-ui-core/icons';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    onOpen: () => void;
};

/**
 * Opens the console image carousel in a popup. Uses a native `<button>` instead of Hammer
 * `IconButton` / `Button` because this control is absolutely positioned over a busy
 * interactive surface (carousel + thumbnails). A plain button keeps stacking, hit target,
 * and focus behavior predictable next to `ImageSlider` internals; `IconButton` can add
 * wrappers or defaults that fight that layout. Styling reuses `transparentNeutralClasses`
 * from hammer-ui’s icon-button tokens for visual parity without importing the full control.
 *
 * @see BiddingConsoleGalleryVideoPip for the same pattern on the live-video PIP overlay.
 */
export const BiddingConsoleGalleryImageLightboxButton = ({ onOpen }: Props) => (
    <button
        aria-label="Open image in new window"
        className={cn(
            'hui-focus-visible-outline flex items-center justify-center rounded-full disabled:text-text-disabled',
            'absolute bottom-xs right-0 z-20',
            'h-lg min-h-lg w-lg min-w-lg',
            transparentNeutralClasses
        )}
        onClick={onOpen}
        type="button"
    >
        <ArrowsOutSimple
            $withoutAriaLabel
            className="rotate-[10deg]"
            color="inherit"
            size="sm"
        />
    </button>
);
